import { Node } from '@contentful/rich-text-types'

import EmbedCollapsingSection from './EmbedCollapsingSection'
import WhyTrustUsSection from './WhyTrustUsSection'
import EmbedSocialMedia from './EmbedSocialMedia'
import EmbedImage from './EmbedImage'
import EmbedVideo from './EmbedVideo'
import EmbedPrerendered from './EmbedPrerendered'
import MethodologySection from './MethodologySection'

interface EmbeddedComponentProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields: any
  id?: string
}

// Mapping from contentful contentTypes to components
const EMBEDDED_ENTRY_COMPONENTS: Record<
  string,
  React.FC<EmbeddedComponentProps>
> = {
  video: EmbedVideo,
  postEmbedSocialMedia: EmbedSocialMedia,
  postEmbedImage: EmbedImage,
  postEmbedCollapsingSection: EmbedCollapsingSection,
  postEmbedMethodologySection: MethodologySection,
  postEmbedWhyTrustUsSection: WhyTrustUsSection,
}

export interface EmbeddedEntryProps {
  node: Node
  serverData?: ServerData
}

const EmbeddedEntry: React.FC<EmbeddedEntryProps> = ({
  node,
  serverData,
}: EmbeddedEntryProps) => {
  const entryId = node.data.target?.sys?.id
  if (!entryId) return null

  try {
    const contentType = node.data.target.sys?.contentType?.sys?.id as
      | string
      | undefined

    if (contentType && !!EMBEDDED_ENTRY_COMPONENTS[contentType]) {
      const EmbeddedEntryComponent = EMBEDDED_ENTRY_COMPONENTS[contentType]
      return (
        <EmbeddedEntryComponent
          fields={node.data.target.fields}
          id={entryId}
          key={`embed-${contentType}-${entryId}`}
        />
      )
    }

    return (
      <EmbedPrerendered
        id={entryId}
        key={`embed-prerendered-${entryId}`}
        serverData={serverData}
      />
    )
  } catch (e) {
    console.error(`Caught exception rendering EmbeddedEntry`, node)
    console.log(e)
    return null
  }
}

export default EmbeddedEntry
